import React from 'react';

import { type UseQueryOptions, useQuery } from '@lumapps/base-api/react-query';

import { type GetPlatformUserDirectoryParams, userDirectoryQueryKeys, getPlatformUserDirectory } from '../api';
import { UserDirectory } from '../types';

export interface UseGetPlatformUserDirectoryParams extends GetPlatformUserDirectoryParams {
    /**
     * Optional callback to execute if the API call fails.
     */
    onError?: () => void;
}

/**
 * A hook to fetch the main platform user directory.
 */
export const useGetPlatformUserDirectory = (
    { action, fields, onError }: UseGetPlatformUserDirectoryParams,
    options?: UseQueryOptions<UserDirectory>,
) => {
    const query = useQuery<UserDirectory>({
        ...options,
        queryKey: userDirectoryQueryKeys.platformDirectory({ action, fields }),
        queryFn: async () => getPlatformUserDirectory({ action, fields }),
    });

    /**
     * If the API call results in an error, we execute the provided
     * onError callback.
     */
    React.useEffect(() => {
        if (query.isError && onError) {
            onError();
        }
    }, [onError, query.isError]);

    return query;
};
